/* eslint-disable no-undef */
import axios from 'axios';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

import { useToken } from '@/context/useToken';
import { useLocation, useNavigate } from 'react-router-dom';

export const getApiUrl = () => {
  if (process.env.VITE_NODE_ENV === 'development') {
    return 'http://localhost:5001/v1';
  }
  if (process.env.VITE_NODE_ENV === 'production') {
    return 'https://api.profoundpros.com/v1';
  }
};

export const getDomain = () => {
  if (process.env.VITE_NODE_ENV === 'development') {
    return 'localhost';
  }
  if (process.env.VITE_NODE_ENV === 'production') {
    return '.profoundpros.com';
  }
};

export const getClientDomain = () => {
  if (process.env.VITE_NODE_ENV === 'development') {
    return 'http://localhost:5173/';
  }
  if (process.env.VITE_NODE_ENV === 'production') {
    return 'https://app.profoundpros.com/';
  }
};

export const getToken = () => {
  return Cookies.get('token');
};

export const getUserId = () => {
  const token = getToken();
  if (token) {
    const decodedToken = jwtDecode(token);
    return decodedToken.id; // Adjust this based on your token's structure
  }
  return null;
};

const publicRoutes = [
  '/',
  '/bookings',
  '/favourites',
  '/inbox',
  '/search',
  '/settings',
  '/signup'
];

export const useAuth = () => {
  const { setToken } = useToken();
  const location = useLocation();
  const navigate = useNavigate();

  axios.interceptors.request.use((config) => {
    if (!config.url.includes('s3.us-west-2')) {
      config.headers['Authorization'] = `Bearer ${getToken()}`;
    }
    return config;
  });
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        // Skip redirect logic if the failed request was to the login endpoint
        const isLoginOrVerifyGuest =
          error.config.url.includes('/v1/login') ||
          error.config.url.includes('/user/login-with-code');
        if (!isLoginOrVerifyGuest) {
          Cookies.remove('token', { domain: getDomain() });
          setToken(null);
          if (!publicRoutes.includes(location.pathname)) {
            navigate('/');
          }
        }
        throw error;
      }
      throw error;
    }
  );
};

export const formatAndThrowApiError = (err) => {
  let errMessage = 'Something went wrong.';
  if (err.response?.status === 500) {
    errMessage = 'Something went wrong.';
  } else if (err.response?.data?.message) {
    errMessage = err.response.data.message;
  } else if (err.message) {
    errMessage = err.message;
  }
  throw Error(errMessage);
};
